var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('van-nav-bar',{staticClass:"nav-bar",attrs:{"left-text":"返回","left-arrow":""},on:{"click-left":_vm.back}}),_c('iframe',{attrs:{"id":"frame","src":_vm.$route.query.url,"onload":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }